import { GET_MEETING_ROOM_DETAILS_ACTION_TYPE, INSERT_UPDATE_MEETING_ROOM_ACTION_TYPE } from "../../../../../utils/constants";


const initialState = [];

function MeetingRoomReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_MEETING_ROOM_DETAILS_ACTION_TYPE:
      return [...state, payload];
    case INSERT_UPDATE_MEETING_ROOM_ACTION_TYPE:
      return [...state, payload];
    default:
      return state;
  }
};

export default MeetingRoomReducer;